<template>
  <div class="risk-panel">
    <v-select
      :class="[
        'main-select',
        'risk-panel-select',
        {
          'risk-panel-select_with-icon': analyse.factor > 0,
          'main-select_active': isSelectOpened,
        },
      ]"
      @input="handleSelectChange"
      id="risk-panel-select"
      :value="selectedValueOption"
      :options="riskOptions"
      :searchable="false"
      :clearable="false"
      @open="onOpenSelect"
      @close="onCloseSelect"
    >
      <template #option="{ label, code }">
        <p :id="label" class="risk-panel-select-option">{{ label }}</p>
        <main-tooltip v-if="code === 1" :target="label" :tooltipValue="label" :placement="'top'" />
      </template>
    </v-select>

    <img
      id="risk-panel-info-icon"
      v-if="analyse.factor > 0"
      class="risk-panel-info-icon"
      src="../files/info-icon.svg"
      alt="info icon"
    />
    <main-tooltip
      target="risk-panel-info-icon"
      v-if="analyse.factor > 0"
      tooltipValue="В текущей версии при просмотре зон ОФП противопожарные стены не учитываются"
    />

    <main-button @click="$emit('onFilterButtonClick')" v-if="analyse.factor > 0" class="risk-panel-filter-button"
      >Фильтр</main-button
    >

    <div v-if="analyse.factor === 0" class="risk-panel-factors-line">
      <div
        class="risk-panel-factors-line-block"
        :key="color"
        :style="{ 'background-color': color }"
        v-for="{ value, color, degree } in riskFactorValues"
      >
        {{ value }} <sup>{{ degree }}</sup>
      </div>
    </div>

    <div v-if="analyse.factor === 1" class="risk-panel-factors-line">
      <div
        class="risk-panel-factors-line-block"
        :key="color"
        :style="{ 'background-color': color }"
        v-for="{ value, color } in thermalIntensityValues"
      >
        {{ value }}
      </div>
    </div>

    <div v-if="analyse.factor === 2" class="risk-panel-factors-line">
      <div
        class="risk-panel-factors-line-block"
        :key="color"
        :style="{ 'background-color': color }"
        v-for="{ value, color } in overpressureValues"
      >
        {{ value }}
      </div>
    </div>
  </div>
</template>

<script>
import MainButton from "./ui/MainButton";
import MainTooltip from "./ui/MainTooltip.vue";

export default {
  props: {
    selectValue: Number,
    analyse: Object,
  },
  components: {
    MainButton,
    MainTooltip,
  },
  data() {
    return {
      isSelectOpened: false,
      riskOptions: [
        { code: 0, label: "Потенциальный риск" },
        { code: 1, label: "Интенсивность теплового излучения, кВт/м²" },
        { code: 2, label: "Избыточное давление ΔP, кПа" },
      ],
      riskFactorValues: [
        { value: ">10", degree: "-3", color: "#A3333D" },
        { value: "10", degree: "-4", color: "#DA3E52" },
        { value: "10", degree: "-5", color: "#F2E94E" },
        { value: "10", degree: "-6", color: "#96E6B3" },
        { value: "10", degree: "-7", color: "#A3D9FF" },
        { value: "10", degree: "-8", color: "#A6ABB4" },
        { value: "0", degree: "", color: "#fff" },
      ],
      thermalIntensityValues: [
        { value: ">50", color: "#8B0204" },
        { value: "10.5", color: "#FF1E1E" },
        { value: "7.0", color: "#FFD74A" },
        { value: "4.2", color: "#3CFF5F" },
        { value: "1.4", color: "#5591FF" },
        { value: "0.5", color: "#808080" },
        { value: "0", color: "#fff" },
      ],
      overpressureValues: [
        { value: ">100", color: "#8B0204" },
        { value: "50", color: "#FF1E1E" },
        { value: "28", color: "#FFD74A" },
        { value: "12", color: "#3CFF5F" },
        { value: "5", color: "#5591FF" },
        { value: "3", color: "#808080" },
        { value: "0", color: "#fff" },
      ],
    };
  },
  computed: {
    selectedValueOption() {
      return this.riskOptions.find((item) => item.code === this.selectValue);
    },
  },
  methods: {
    handleSelectChange(event) {
      this.$emit("onRiskSelectChange", event);
    },
    onOpenSelect() {
      this.isSelectOpened = true;
    },
    onCloseSelect() {
      this.isSelectOpened = false;
      // Снимает фокус с инпута после выбора элемента
      setTimeout(() => {
        document.activeElement.blur();
      }, 0);
    },
  },
};
</script>

<style scoped>
.risk-panel {
  position: absolute;
  top: 16px;
  left: 21px;
  display: flex;
  z-index: 15;
}
.risk-panel-select {
  width: 280px;
}
.risk-panel-filter-button {
  height: 36px;
  padding: 0 24px;
}
.risk-panel-info-icon {
  position: absolute;
  left: 8px;
  top: 10px;
  z-index: 2;
}
.risk-panel-factors-line {
  display: flex;
  height: 36px;
}
.risk-panel-factors-line-block {
  min-width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: var(--black-color);
}
.risk-panel-select-option {
  color: var(--black-color);
  display: block;
  max-width: 240px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0;
}
</style>
